export default __webpack_public_path__ + "static/media/gallery-14-3.ef87452e.webp";